export const HELPDESK_LINK = {
  CONSENT_TRANSACTION_RECORD: 'https://cookiewow.com/help/cookie-wow-tutorials/consent-transaction-record',
  COOKIE_SCANNER: 'https://cookiewow.com/help/cookie-wow-tutorials/knowledge_article-b47a151e',
  MANAGE_COOKIE: 'https://cookiewow.com/help/cookie-wow-tutorials/manage-cookies-7d5efbb1',
  COOKIE_PACKAGES: 'https://cookiewow.com/help/package-service-detail',
  CANCEL_FREETRIAL: 'https://cookiewow.com/help/package-service-detail/free-trial-0762577e',
}
